import { CurrencyRecord, SupportedCurrency } from '../domain/currency';
import { TransportOrder } from '../domain/transportOrder';
import { parsePrice } from './currency';

export const calculateProfitForCurrency = (transportOrder: TransportOrder, forCurrency: SupportedCurrency, currencyRecord: CurrencyRecord) => {
    const freightValue = parsePrice(transportOrder.freight.value);
    const clientValue = parsePrice(transportOrder.freight.clientValue);

    if (isNaN(freightValue) || isNaN(clientValue)) {
        return 0;
    }

    const { freight } = transportOrder;
    const clientCurrency = freight.clientCurrency;

    if (forCurrency === clientCurrency) {
        if (forCurrency === freight.currency) {
            return clientValue - freightValue;
        }

        const currencyRate = currencyRecord[forCurrency];
        const convertedContractorValue = freightValue / currencyRate.exchangeRate;

        return clientValue - convertedContractorValue;
    }

    const convertedClientValue = clientValue / currencyRecord[forCurrency].exchangeRate;
    const convertedContractorValue = freight.currency === forCurrency ? freightValue : freightValue / currencyRecord[forCurrency].exchangeRate;

    return convertedClientValue - convertedContractorValue;
};